import { ChangeDetectorRef, DestroyRef, inject } from '@angular/core';

export abstract class BaseSubscriberAdvertiserComponent {
  protected _destroyRef = inject(DestroyRef);
  protected _cdRef = inject(ChangeDetectorRef);
}
